// NSW region list. Add QLD regions here when the user asks.
export const NSW_REGIONS = [
  "Canterbury Bankstown",
  "Central Coast",
  "Eastern Suburbs",
  "Hills District",
  "Inner West",
  "Liverpool Region",
  "Lower North Shore",
  "MacArthur Region",
  "Melbourne",
  "Newcastle Region",
  "Northern Beaches",
  "Parramatta Greater Region",
  "South Coast Illawarra",
  "St. George",
  "Sutherland Shire",
  "Upper North Shore",
  "Western Sydney",
];

export function regionsForState(state) {
  if (state === "NSW") return NSW_REGIONS;
  return [];
}
